export const isBoolean = value => /true|false/i.test(value);

export const stringToBoolean = value =>
    isBoolean(value) ? (value === 'true' ? true : value === 'false' ? false : value) : false;

export const roundToTwoDigits = value => {
    const rounded = value ? Math.round((value + Number.EPSILON) * 100) / 100 : value;
    return rounded ? rounded.toFixed(2) : rounded;
};
